import { render, staticRenderFns } from "./CancellationABTests.vue?vue&type=template&id=80cc9c28&"
import script from "./CancellationABTests.vue?vue&type=script&lang=ts&"
export * from "./CancellationABTests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports